import {
  TableCell,
  TableRow as MuiTableRow
} from '@mui/material'
import { RenderValue }    from 'components/render'
import { useTranslator } from 'hooks/translator';

export default function TableRow({row, columns, index, section}) {
  //const [contextMenu, setContextMenu] = React.useState(null);
  //const handleMenu = React.useContext(MenuItemContext)
  //const menu = handleMenu && handleMenu(row)

  const handleContextMenu = (event) => {
    // disable context menu, when text is selected
    if (window.getSelection().type == 'Range')
      return false
    
    if (menu?.length) {
      event.preventDefault();
      setContextMenu(
        contextMenu === null
          ? {
              x: event.clientX - 15,
              y: event.clientY - 6,
            }
          : null
      )
    }
  }

  return (
    <MuiTableRow 
      sx={row.rowProps ? row.rowProps : {}}
      id={"row_" + index}
      gears-id={row.id}
      //onContextMenu={handleContextMenu}
      onClick={row.onClick}          
      style={{cursor: row.onClick ? 'pointer' : undefined}}
      hover
      key={index}
    >
      <TableRows columns={columns} row={row} section={section}/>
      {/*<TableRowMenu menu={menu} contextMenu={contextMenu} setContextMenu={setContextMenu}/>*/}
    </MuiTableRow>
  )
}

const TableRows = ({row, columns, section}) => {
  const { translator } = useTranslator()

  return columns.map((column, index) => {
    const sx = row.rowProps?.fontWeight?  { fontWeight: row.rowProps.fontWeight } : {}
    const displayProps = column.field == 'label'
      ? column.displayProps
      : row.displayProps || column.displayProps
    const value = _.get(row, "cells." + column.field)
    const translatedValue = section ? translator.toListValue(section.key, value) : value

    return (
      <TableCell key={index} {...column.cellProps} >
        <RenderValue section={section} sx={sx} displayProps={displayProps}>
          {translatedValue}
        </RenderValue>
      </TableCell>
    )
  })
}
